import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs/index';
import { catchError, tap } from 'rxjs/internal/operators';
import { environment } from '../../environments/environment';
import { EnvironmentService } from '../environment.service';
import { TranslateService } from '@ngx-translate/core';  
import {Router } from '@angular/router';
@Injectable({
    providedIn: 'root'
})


export class LoginService {

    // store the URL so we can redirect after logging in
    redirectUrl: string;
	err: any;
    loginUrl;
    adminUrl;
	username;
    password;
    WrongMessage;
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json'
        })
    };
    login(user): Observable<any> {
        this.translate.get('Common.WrongMSG').subscribe((res: string) => {
           this.WrongMessage = res;
        })
        this.err = { success: false, message: this.WrongMessage, user_data: null };
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
				'Authorization': `Basic ${btoa(this.username + ':' + this.password)}`
            })
        };
        console.log("user->",user,"->",this.loginUrl)
        return this.http.post<any>(`${this.loginUrl}/developer/login`, user, this.httpOptions).pipe(
            // tap(data =>  this.isLoggedIn = true),
            tap(),
            catchError(this.handleError('login', this.err))
        );
    }



    /* logout() {
        localStorage.clear();
		this.router.navigate(['/']);
    } */

    isLoggedIn(url: string): boolean {
		const userData = JSON.parse(localStorage.getItem('user'));
		if(userData) {
			return true
		}else {
			return false;
		}
    }

    constructor(private http: HttpClient, private envService: EnvironmentService,public translate: TranslateService,private router: Router) {
        this.loginUrl = this.envService.read('apiUrl');
		this.username = this.envService.getCredential('username');
		this.password = this.envService.getCredential('password');
    }
	resetPasswordMail(args): Observable<any> {
		const userData = JSON.parse(localStorage.getItem('user'));
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
				'Authorization': `Basic ${btoa(this.username + ':' + this.password)}`
            })
        };
        //this.httpOptions.params = null;
        return this.http.post<any>(`${this.loginUrl}/developer/password/reset/mail`, args, this.httpOptions).pipe(
            // tap(data =>  this.isLoggedIn = true),
            tap(),
            catchError(this.handleError('resetmail', this.err))
        );
    }
	resetPassword(args): Observable<any> {
			this.httpOptions = {
				headers: new HttpHeaders({
					'Content-Type': 'application/json',
					'Authorization': `Basic ${btoa(this.username + ':' + this.password)}`
				})
			};
			//this.httpOptions.params = null;
			return this.http.post<any>(`${this.loginUrl}/developer/password/reset`, args, this.httpOptions).pipe(
				// tap(data =>  this.isLoggedIn = true),
				tap(),
				catchError(this.handleError('reset', this.err))
			);
		}	



    /**
     * Handle Http operation that failed.
     * Let the app continue.
     * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {

            // TODO: send the error to remote logging infrastructure
            console.error('error on operation', operation, error); // log to console instead

            // TODO: better job of transforming error for user consumption
            // this.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }

}
